import Chip from "@mui/material/Chip";

import StockQtyInput from "./StockQtyInput";
import SharePointIcon from "../../../components/CustomIcons/SharePointIcon";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import AddQtyToDrawingModal from "./AddQtyToDrawingModal";

export const masterMaterialsColumns = [
  {
    accessorKey: "description",
    header: "Description",
    enableColumnFilter: true,
    filterVariant: "text",

    size: 200,
  },
  {
    accessorKey: "remainingQty",
    header: "Stock Qty (Remaining)",
    enableColumnFilter: false,
    size: 40,
    enableColumnActions: false,
    enableSorting: false,
    enableEditing: true,
    Cell: ({ row }) => {
      return (
        <StockQtyInput
          row={row}
          defaultValue={row.original.remainingQty}
          name="remainingQty"
          placeholder="Remaining Qty"
        />
      );
    },
  },
  // {
  //   accessorKey: "estCost",
  //   header: "Est. Cost",
  //   enableColumnActions: false,
  //   enableSorting: false,
  //   size: 20,
  // },
  {
    accessorKey: "unit",
    enableColumnFilter: false,
    header: "Unit",
    size: 40,
    enableColumnActions: false,
    enableSorting: false,
    Cell: () => {
      return "Ft";
    },
  },
  {
    accessorKey: "estCost",
    header: "Est. Cost $ / unit",
    enableColumnFilter: false,
    size: 40,
    enableColumnActions: false,
    enableSorting: false,
    Cell: ({ row }) => {
      return (
        <StockQtyInput
          row={row}
          name="estCost"
          placeholder="Est. Cost"
          defaultValue={row.original.estCost}
        />
      );
    },
  },

  {
    accessorKey: "max",
    header: "Max $",
    size: 40,
    enableColumnFilter: false,
    enableColumnActions: false,
    enableSorting: false,
  },
  {
    accessorKey: "min",
    header: "Min $",
    size: 40,
    enableColumnFilter: false,
    enableColumnActions: false,
    enableSorting: false,
  },
  {
    accessorKey: "remarks",
    header: "Remarks",
    enableColumnFilter: false,
    enableColumnActions: false,
    enableSorting: false,
  },
];

export const SubTableCols = [
  // {
  //   accessorKey: "materialCode",
  //   header: "Part/Tag/Mark #",
  //   size: 40,
  //   // Cell: ({ row }) => {
  //   //   const materials = row.original.materials;
  //   //   console.log({ materials });
  //   //   return materials?.map((m) => {
  //   //     return <Box>- {m?.bulkMaterial?.item}</Box>;
  //   //   });
  //   // },
  // },
  {
    accessorKey: "po.poDate",
    header: "PO Date",
    size: 40,
  },
  {
    accessorKey: "po.poNumber",
    header: "PO #",
    size: 60,
  },
  // {
  //   accessorKey: "reqQty",
  //   header: "Req. Qty",
  //   aggregationFn: "sum",
  //   AggregatedCell: ({ cell }) => <div>{cell.getValue()}</div>,
  //   size: 20,
  // },
  {
    accessorKey: "procuredQty",
    header: "Procured Qty",
    aggregationFn: "sum",
    AggregatedCell: ({ cell }) => <div>{cell.getValue()}</div>,
    size: 20,
  },

  {
    accessorKey: "unit",
    header: "Unit",
    aggregationFn: "sum",
    AggregatedCell: ({ cell }) => <div>{cell.getValue()}</div>,
    size: 20,
    Cell: () => "Ft",
  },
  {
    accessorKey: "stockQty",
    header: "Remaining Qty",
    size: 20,
    Cell: () => {
      return <div>0</div>;
    },
  },
  {
    accessorKey: "cost",
    header: "PO Cost",
    // aggregationFn: "sum",
    // AggregatedCell: ({ cell }) => <div>{cell.getValue()}</div>,
    size: 40,
    Cell: ({ row }) => {
      const procuredQty = row.original?.procuredQty;
      const cost = row.original?.cost;

      return procuredQty && cost ? procuredQty * cost : "";
    },
  },
  {
    accessorKey: "mrv.mrvNumber", //to be corrected
    header: "MRV #",
    size: 50,
    Cell: ({ row }) => {
      const mrvNumber = row.original.mrv?.mrvNumber;
      console.log("material records row", row.original);
      return mrvNumber ? (
        <Chip
          icon={<InsertDriveFileIcon />}
          label={mrvNumber}
          //   component="a"
          //   href="#basic-chip"
          //   clickable
          // onClick={() => onClick(c)}
          variant="outlined"
        />
      ) : (
        ""
      );
    },
    // Cell: ({ cell, row }) => {
    //   const onClick = () => {
    //     // just do navigate()
    //     setHash(window.location.hash, "scm-tab", "Purchase%20Order");
    //     window.location.reload();
    //   };
    //   // const polink = `/supply-chain-management#scm-tab=Purchase%20Order`
    //   return (
    //     // <Link to={`${paths.main_pv}/#main-nav=MRQ`}>
    //     <Button size="small" onClick={onClick}>
    //       {cell.getValue()[0]?.mcsPurchaseOrder?.po_name || ""}
    //     </Button>
    //   );
    // },
  },
  {
    accessorKey: "vendor.name",
    header: "Vendor Docs",
    size: 40,
    enableColumnActions: false,
    enableSorting: false,
    Cell: ({ row }) => {
      return (
        <Chip
          icon={
            <SharePointIcon size={18} sx={{ transform: "translateX(7px)" }} />
          }
          label={row.original.vendor?.name}
          //   component="a"
          //   href="#basic-chip"
          //   clickable
          // onClick={() => onClick(c)}
          variant="outlined"
        />
      );
    },
  },
  {
    accessorKey: "heatNumber",
    header: "Heat #",
    // Cell: ({ cell, row }) => {
    //   return <div>{cell.getValue()[0]?.selected_cost || ""}</div>;
    // },
    // aggregationFn: "sum",
    // AggregatedCell: ({ cell }) => (
    //   <div>{cell.getValue()[0]?.selected_cost}</div>
    // ),
    size: 40,
    enableColumnActions: false,
    enableSorting: false,
  },
  {
    accessorKey: "projectName",
    header: "Project Name",
    size: 40,
    enableColumnActions: false,
    enableSorting: false,
    enableEditing: true,
    Cell: ({ row }) => {
      return (
        <Chip
          icon={<InsertDriveFileIcon />}
          label={"PV-Demo"}
          //   component="a"
          //   href="#basic-chip"
          //   clickable
          // onClick={() => onClick(c)}
          variant="outlined"
        />
      );
    },
  },
  {
    accessorKey: "drawingNumber",
    header: "Drawing Name",
    size: 40,
    enableColumnActions: false,
    enableSorting: false,
    enableEditing: true,
    Cell: ({ row }) => {
      return (
        <Chip
          icon={<InsertDriveFileIcon />}
          label={"PV-Drawing-Test"}
          //   component="a"
          //   href="#basic-chip"
          //   clickable
          // onClick={() => onClick(c)}
          variant="outlined"
        />
      );
    },
  },

  // {
  //   accessorKey: "Move",
  //   header: "Move",
  //   size: 40,
  //   enableColumnActions: false,
  //   enableSorting: false,
  //   enableEditing: true,
  //   Cell: ({ row }) => <AddQtyToDrawingModal material={row} />,
  // },
];
